module.exports = __webpack_public_path__ + "static/img/redux.b85d3b11.png";